
seedWebServices.service('HelpdeskService', ['$http', '$cacheFactory', '$uibModal', '$q','TranslationService',
    function ($http, $cacheFactory, $uibModal, $q, TranslationService) {
        var serviceCache = $cacheFactory('HelpdeskService');

        var URL = '../Api/Helpdesk/';

        var ctrl = this;

        this.resetCache = function () {
            serviceCache.removeAll();
        };

        this.getIssues = function (filterString, options, skipNumber, takeNumber, sort, parentFilter) {
            return $http.put(URL + '/SearchIssues', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, parentFilter: parentFilter }, { cache: serviceCache });
        };

        this.getIsssue = function (id) {
            var cache = serviceCache;
            return $http.get(URL + 'GetIssue', {
                params: { id: id },
                cache: cache
            });
        };

        this.getIssuesCount = function () {
            return $http.get(URL + 'GetIssuesCount', {
                params: {},
                cache: serviceCache
            });
        };

        this.getIssuesColumns = function (column, filterString, skipSize, takeSize, parentFilter) {
            return $http.put(URL + '/GetIssuesColumns',
                {
                column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize, parentFilter: parentFilter
                }
            );
        };

        this.saveIssue = function (item, stage) {
            return $http.put(URL + '/SaveIssue', {
                item: item,
                stage: stage
            }, true);
        };

        this.saveChanges = function (changes) {
            return $http.put(URL + '/SaveChanges', changes, true);
        };        

        this.generateCreditNotePDF = function (issueID, statusID) {
            return $http.get(URL + '/GenerateCreditNotePDF', {
                params: {
                    issueID: issueID,
                    statusID: statusID
                },
                cache: false,
                responseType: 'arraybuffer'
            })
        }

        this.getStagesByID = function () {
            var deferred = $q.defer();
            this.getStages().then(function (response) {
                var stages = ctrl.stagesByKey(response.data);
                //NextStages to list
                /*
                for (var stageID in stages) {
                    var stage = stages[stageID];
                    if (stage.NextStages) {
                        stage.NextStages = stage.NextStages.split(';');
                        stage.NextStages = stage.NextStages.map(function (stage) {
                            return stage.trim();
                        });
                    }
                }
                */
                return deferred.resolve(stages);    
            });
            return deferred.promise;
        };


        this.stagesByKey = function (stages) {
            var stagesByKey = {};
            stages.forEach(
                function (status) {
                    stagesByKey[status.StageID] = status;
                }
            );
            return stagesByKey;
        }


        this.getIssueTypes = function () {
            this.issueTypes = [
                { Key: 'INDUSTRIAL', Value: 'Industrial' },      
                { Key: 'LOGISTIC', Value: 'Logistic' },      
                { Key: 'COMERCIAL', Value: 'Comercial' },  
                { Key: 'SHIPMENT', Value: 'Shipment' },  
                
            ];
            return this.issueTypes;
        };

        this.getOrdersQuery = function (query, contactID) {
            var cache = serviceCache;
            return $http.get(URL + '/GetOrdersQuery', {
                params: {
                    query: query,
                    contactID: contactID
                },
                cache: cache
            });
        };

        this.getContactsQuery = function (query) {
            var cache = serviceCache;
            return $http.get(URL + '/GetContactsQuery', {
                params: {
                    query: query,
                },
                cache: cache
            });
        };

        this.getNewIssue = function ()
        {
            return $http.get(URL + '/GetNewIssue', {
                params: {}
            });
        };

        this.getIssueDetails = function (issueID) {
            var cache = serviceCache;
            return $http.get(URL + '/GetIssueDetails', {
                params: {
                    issueID: issueID,
                },
                cache: cache
            });
        };

        this.validateStateComplete = function (issue, stage, toStageID) {
            return $http.put(URL + '/ValidateStateComplete',
                {
                    issue: issue,
                    stage: stage,
                    toStageID: toStageID
                }, true);
        };

        this.updateState = function (issue, stageID, oldStage, goBack, emailSent) {
            return $http.put(URL + '/UpdateState',
                {
                    issue: issue,
                    stageID: stageID,
                    oldStage: oldStage,
                    goBack: goBack,
                    emailSent: emailSent,
                    //comments: comments
                }, true);
        };

        this.getIssueActivities = function (issueID) {
            var cache = serviceCache;
            return $http.get(URL + '/GetIssueActivities', {
                params: {
                    issueID: issueID,
                },
                cache: cache
            });
        };

        this.getIssueEvents = function (issueID) {
            var cache = serviceCache;
            return $http.get(URL + '/GetIssueEvents', {
                params: {
                    issueID: issueID,
                },
                cache: cache
            });
        };

        this.getOrderSkus = function (orderID) {
            var cache = serviceCache;
            return $http.get(URL + 'GetOrderSkus', {
                params: { orderID: orderID },
                cache: cache
            });
        };

        //function (filterString, options, skipNumber, takeNumber, sort, parentFilter) {

        this.searchStages = function (filterString, options, skipNumber, takeNumber, sort, parentFilter) {
            return $http.put(URL + '/SearchStages', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, parentFilter: parentFilter }, { cache: serviceCache });
        };

        this.searchAlternativeApprovals = function (filterString, options, skipNumber, takeNumber, sort, parentFilter) {
            return $http.put(URL + 'SearchAlternativeApprovals', { filteString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, parentFilter: parentFilter }, { cache: serviceCache });
        }

        this.addAlternativeApproval = function (alternativeApproval) {
            return $http.post(URL + 'AddAlternativeApproval', alternativeApproval);
        }

        this.updateAlternativeApproval = function (alternativeApproval) {
            return $http.put(URL + 'UpdateAlternativeApproval', alternativeApproval);
        }

        this.deleteAlternativeApproval = function (alternativeApprovalID) {
            return $http.delete(URL + 'DeleteAlternativeApproval', {
                params: { alternativeApprovalID: alternativeApprovalID }
            });
        }

        this.getStages = function () {
            var cache = serviceCache;
            return $http.get(URL + 'GetStages', {
                params: {},
                cache: cache
            });
        };

        this.addStage = function (stage) {
            return $http.post(URL + 'AddStage', stage);
        };

        this.updateStage = function (stage) {
            return $http.put(URL + 'UpdateStage', stage);
        };

        this.deleteStage = function (stageID) {
            return $http.delete(URL + 'DeleteStage', {
                params: { stageID: stageID }
            });
        };

        ctrl.isApprovalRequired = function (creditNoteClaim, approval) {
            //console.log('approval', approval, creditNoteClaim);
            if (!approval.MinCreditApproval) {
                if (approval.MaxCreditApproval) {
                    return creditNoteClaim <= approval.MaxCreditApproval;
                }
                else {
                    return true;
                }
            }
            if (creditNoteClaim >= approval.MinCreditApproval) {
                if (creditNoteClaim <= approval.MaxCreditApproval) {
                    return true;
                }
            }
            return false;
        };

        this.updateApproval = function (approval) {
            //approval.IssueID = issueID;
            //var data = {
            //    issueID: issueID,
            //    approval: approvale
            //}
            return $http.put(URL + 'UpdateApproval', approval);
        };

        this.validateApproval = function (approval) {
            //approval.IssueID = issueID;
            return $http.put(URL + 'ValidateApproval', approval);
        };

        this.showCreditNoteField = function (issue, fieldName) {
            if (issue.HasCreditNote) {
                return true;
            }
            var costFields = ['CreditNoteClaim', 'CreditNoteFinal', 'CreditNoteOrderID', 'AccountNumber'];
            var index = costFields.findIndex(function (name) {
                if (name == fieldName) {
                    return true;
                }
            });
            var isCost = index >= 0;
            return !isCost;
        };
    }
    
]);